import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpService } from 'src/app/services/http/http.service';

@Injectable({
    providedIn: 'root'
})
export class ListMembersService extends HttpService {
    listMembersHash(filter: string): Observable<any> {
        const url = 'members/list/search';
        return this.post(url, { app: 'member', version: 1 }, {value : filter});
    }
}
